
import { defineComponent, onMounted, onUnmounted, ref, computed } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import GameService from '@/services/GameService';
import { UserUtils } from '@/utils/UserUtils';
import { useStore } from 'vuex';


export default defineComponent({
  props: {
    gameId: String
  },
  name: "viewGamesPlay",

  setup(props){
    const store = useStore();
    const userObj = store.getters['auth/user'];
    const username = ref(userObj.username);

    const gameView = ref('');
    const isFullScreen = ref(false);
    const label = computed(() => {
      return store.getters['config/configLabel'];
    });

    const assetUrl = computed(() => {
      return store.getters['config/assetUrl'];
    })

    const maxScreen = () => {
      isFullScreen.value = true;
    }

    const restoreView = () => {
      isFullScreen.value = false;
    }

    const title = ref('');
    let strFolder:string;
    (async() => {
      // console.log(props.gameId)
      // const gameDetails = await GameUtils.fetchPublishedGame(props.gameId);
      const gameDetails = await GameService.getGame(props.gameId);
      console.log(gameDetails)
      const apiKey:string = await UserUtils.fetchApiKey(props.gameId);
      title.value = gameDetails.data.viewModel.game.title;
      strFolder = gameDetails.data.viewModel.game.name + '_' + gameDetails.data.viewModel.game.version.replaceAll('.', '_');
      gameView.value = assetUrl.value + 'blob/releases/WebGL/' + props.gameId + '/' + strFolder + '/index.html?auth=' + apiKey;
    })();

    const checkFocusPlayView = () => {
      if (document.activeElement.tagName === "IFRAME") {
        // console.log('Play view focus')
        store.dispatch('game/playViewIsFocus');
      }
    }

    onMounted(() => {
      window.addEventListener("blur", checkFocusPlayView);
    })

    onUnmounted(() => {
      window.removeEventListener("blur", checkFocusPlayView);
      store.dispatch('game/playViewIsBlur');
    });

    return{
      title,
      username,
      gameView,
      isFullScreen,
      maxScreen,
      restoreView,
      label,
    }
  }
});
